import { MagicFilled } from "@aircall/icons";
import { Flex, Typography } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import { useSummaryRule } from "@/hooks/useSummaryRule/useSummaryRule";
import { NoDataBanner } from "../NoDataBanner/NoDataBanner";

import { ContentProps } from "./SectionSummary.decl";

import { useCall } from "@/hooks/useCall/useCall";

function Content({ call }: ContentProps) {
  const { t } = useTranslation();

  if (!call?.summary) {
    return (
      <NoDataBanner
        text={t("call_context.no_summary_generated_text")}
        data-test="no-summary-generated"
      />
    );
  }

  return (
    <Typography variant="bodyRegularM" data-test="call-context-summary-text">
      {call.summary}
    </Typography>
  );
}

export function SummarySection() {
  const { t } = useTranslation();

  const { call } = useCall();
  const { shouldDisplaySummary } = useSummaryRule();

  if (!shouldDisplaySummary) {
    return null;
  }

  return (
    <Flex gap="s" flexDirection="column">
      <Flex gap="xxs" alignItems="center">
        <Typography variant="headingMediumS">
          {t("call_context.summary_title")}
        </Typography>
        <MagicFilled size={16} />
      </Flex>
      <Content call={call} />
    </Flex>
  );
}
